import React from 'react';
import { Table } from 'semantic-ui-react';

const SingleCellRow = ({children, colSpan}) => (
  <Table.Row>
    <Table.Cell textAlign='center' colSpan={colSpan}>
      { children }
    </Table.Cell>
  </Table.Row>
);

export default SingleCellRow;
